module.exports = __webpack_public_path__ + "img/T4-B-xh_16.24296aaf.png";